<template>
  <div class="dynamic">
    <div class="dynamicTitle">
      <span class="applying">招聘动态</span>
    </div>
    <el-divider></el-divider>
    <div class="dynamicContent" v-for="(item, index) in pageItems" :key="index">
      <router-link :to="{ path: '/Detail', query: { id: item.rec_id } }" class="ConText">
        <p>{{ item.news_title }}</p>
        <span>发布时间：{{ item.public_time | formatdate }}</span>
      </router-link>
      <el-divider></el-divider>
    </div>
    <el-pagination background layout="prev, pager, next" :total="total" :page-size="newsPage.pageSize" @current-change="changeHandle"> </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      total: 0,
      newsPage: {
        pageSize: 4,
        pageIndex: 1
      },
      pageItems: []
    }
  },
  filters: {
    formatdate(value) {
      if (!value) return ''
      return value.slice(0, 10)
    }
  },
  created() {
    this.getFirstNews()
  },
  methods: {
    // 获取文章动态列表
    getFirstNews() {
      this.$axios
        .get('/api/news/list', {
          params: this.newsPage
        })
        .then(result => {
          const { data: res } = result
          console.log(res)
          this.total = res.data.record_count
          this.pageItems = res.data.data
        })
    },
    changeHandle(val) {
      this.newsPage.pageIndex = val
      this.getFirstNews()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.dynamic {
  .dynamicTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .applying {
      font-size: 24px;
    }
    .more {
      a {
        color: #2d8cf0;
        text-decoration: none;
      }
    }
  }
  .el-divider--horizontal {
    @include divider(2px, 15px);
  }
  .dynamicContent {
    .ConText {
      text-decoration: none;
      p {
        color: #555;
        height: 60px;
      }
      span {
        font-size: 14px;
        color: #838383;
      }
    }
    .el-divider--horizontal {
      @include divider(1px, 15px);
    }
  }
}
</style>
